import { Link, useLocation } from "react-router-dom";
// --- img ----------------------------------------------------------------
import {
  placeIcon,
  callIcon,
  mailIcon,
} from "../../assets/images";
// --- style ---------------------------------------------------------------
import "./Footer.scss";

function Footer() {
  const { pathname } = useLocation();
  const handlePathScroll = (to) => (e) => {
    if (pathname === to) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <footer className="footer">
      <div className="footer__inner">
        <h2 className="footer__logo">
          MOB STUDIO
        </h2>

        <address class="footer__contact">
          <p>
            <img src={placeIcon} alt="" aria-hidden="true" />
            대구광역시 중구 동성로 1가 33 2F
          </p>
          <p>
            <img src={callIcon} alt="" aria-hidden="true" />
            <a href="tel:0537164545">053-716-4545</a>
          </p>
          <p>
            <img src={mailIcon} alt="" aria-hidden="true" />
            <a href="mailto:mob_studio@naver.com ">mob_studio@naver.com</a>
          </p>
        </address>

        <nav className="footer__nav" aria-label="Footer Menu">
          <ul>
            <li>
              <Link 
              to="/"
              onClick={handlePathScroll("/")}
              >
                About
              </Link>
            </li>
            <li>
              <Link 
              to="/service"
              onClick={handlePathScroll("/service")}
              >
                Service
              </Link>
            </li>
            <li>
              <Link 
              to="/music"
              onClick={handlePathScroll("/music")}
              >
                Music
              </Link>
            </li>
            <li>
              <Link 
              to="/portfolio"
              onClick={handlePathScroll("/portfolio")}
              >
                Portfolio
              </Link>
            </li>
            <li>
              <Link 
              to="/recruit"
              onClick={handlePathScroll("/recruit")}
              >
                Recruit
              </Link>
            </li>
          </ul>
        </nav>

        <p className="footer__copy">
          {/* Copyright 2025. MOBSTUDIO all rights reserved */}
          © 2025 MOB STUDIO. All rights reserved.
        </p>
      </div>
    </footer>
  )
}

export default Footer